import React from 'react';
import PropTypes from 'prop-types';

import ConfirmWrap from 'common/components/ConfirmWrap/ConfirmWrap';

const Button = ({
  onClick, icon, color, confirm, transparent, confirmMessage, label, outlined, disabled = false,
  additionnalClasses, ...rest
}) => {
  const classNames = ['button', additionnalClasses];

  if (transparent) classNames.push('is-transparent');
  if (outlined) classNames.push('is-outlined');
  if (color) classNames.push(`is-${color}`);
  if (disabled) classNames.push('is-disabled');

  const btn = (
    <button
      type="button"
      onClick={onClick}
      className={classNames.join(' ')}
      disabled={disabled}
      {...rest}
    >
      { icon && (
        <span className="icon">
          <i className={`fas ${icon}`} />
        </span>
      ) }
      { label && (
        <span>{ label }</span>
      ) }
    </button>
  );

  if (confirm) {
    return (<ConfirmWrap message={confirmMessage}>{ btn }</ConfirmWrap>);
  }
  return btn;
};

Button.propTypes = {
  onClick: PropTypes.func,
  icon: PropTypes.string,
  color: PropTypes.string,
  confirm: PropTypes.bool,
  confirmMessage: PropTypes.string,
  label: PropTypes.string,
  transparent: PropTypes.bool,
  outlined: PropTypes.bool,
};

Button.defaultProps = {
  confirm: false,
  icon: null,
  color: null,
  confirmMessage: null,
  label: null,
  onClick() {},
  transparent: false,
  outlined: false,
};

export default Button;
